module.exports = __webpack_public_path__ + "media/images/smart_phone/products/cup_noodle2-17f3b11d29de4a7d8cfd681c3a0f11d1.jpeg";